export const QUERY_TYPE_IDS = {
  CONVERSATION: 'conversation',
  FOLDER: 'folder',
  SEGMENTATION: 'segmentation',
  TSV: 'tsv',
  AUDIENCE: 'audience',
  CAMPAIGN: 'campaign',
  INTEREST: 'interest',
} as const;

export const QUERY_TYPE_LABELS = {
  CONVERSATION: 'Conversation',
  FOLDER: 'Folder',
  SEGMENTATION: 'Segment',
  TSV: 'TSV',
  AUDIENCE: 'Audience',
  CAMPAIGN: 'Campaigns',
  INTEREST: 'Interest',
} as const;

export const QUERY_TYPE_ICONS = {
  CONVERSATION: 'conversation',
  FOLDER: 'folder',
  SEGMENTATION: 'segmentation',
  TSV: 'users',
  AUDIENCE: 'spinner',
  CAMPAIGN: 'icon-play',
  INTEREST: 'heart',
} as const;

export const queryTypeIconMap = Object.fromEntries(
  Object.entries(QUERY_TYPE_IDS).map(([iconKey, sourceId]) => [
    sourceId,
    QUERY_TYPE_ICONS[iconKey],
  ])
) as Record<string, string>;

export const queryTypeLabelIconMap = Object.fromEntries(
  Object.entries(QUERY_TYPE_IDS).map(([iconKey, sourceId]) => [
    sourceId,
    [QUERY_TYPE_LABELS[iconKey], QUERY_TYPE_ICONS[iconKey]],
  ])
) as Record<string, [string, string]>;

